export default __webpack_public_path__ + "static/bigminerLogo-deade44e577ac4849d54001bda0f835e.svg";